import { get, makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { CuotasMod, CuotasModFormValues } from '../models/CuotasMod';
import {CCTPlanCuotaDetails, CCTPlanCuotaDetailsForm} from '../models/CCTPlanCuota';
import { DPI, DPIFormValues } from '../models/dpi';
import { CATCursosL, createCATCursos } from '../models/CATCursos';
import { CATEdiciones, CATEdicionesL } from '../models/CATEdiciones';
import {getTranxTipoCta} from '../models/getTranxTipoCta';
import CATCursos from './CATCursos';
import { PassMod, PassModFormValues, ResetPassMod, ResetPassModFormValues } from '../models/PassWord';


export default class CuotasStore {
   PassRegistry = new Map<any, PassMod>();
   PassReset = new Map<any, ResetPassMod>();
    CATCoursesRegistry = new Map<any,createCATCursos>();
    CATCoursesRegistryL = new Map<any,CATCursosL>();

    CATEdicionesRegistry = new Map<any,CATEdiciones>();
    CATEdicionesRegistry3 = new Map<any,CATEdicionesL>();
    TransXTipoCta = new Map<any,getTranxTipoCta>();
   
    DPIRegistry = new Map<any, CuotasMod>();

    DetailedCuotasRegistry = new Map<any,CCTPlanCuotaDetails>();
    DetailedCuotas = new Map<any,CCTPlanCuotaDetails>();
    

    selectedPassMod: PassMod | undefined = undefined;
    selectedResetPassMod: ResetPassMod | undefined = undefined;
    selectedDPI: DPI | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
    saldo_actual_total:string = ""
    consulta=''; 


    constructor() {
        makeAutoObservable(this)
    }

    get Password() {
        return Array.from(this.PassRegistry.values());
    }

    get ResetPassword(){
        return Array.from(this.PassReset.values());
    }
    // get dpiByCodigo() {
         
    //     return Array.from(this.DPIRegistry.values());
    // }

    get detailedCuotas(){
        return Array.from(this.DetailedCuotasRegistry.values());
    }
    get detailedCuotas2(){
        return Array.from(this.DetailedCuotas.values());
    }
    

     
    
    passRecuperar = async (PassMod: PassModFormValues) => {
        try {
            await agent.Passw.passReload(PassMod);
            runInAction(() => {
                this.selectedPassMod = PassMod;
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }  





    PassResetear = async (ResetPassMod: ResetPassModFormValues) => {
        try {
            await agent.Passw.passReset(ResetPassMod);
            runInAction(() => {
                this.selectedResetPassMod = ResetPassMod;
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }  


}


export const CoursesData = async () => {
    try{
        const getCursos:createCATCursos[] = await agent.CATCursos.getCourses();
    }
    catch{
    }
}